export const isRecordActive = (val) =>
  val === true ||
  val === "Y" ||
  val === "y" ||
  val === "true" ||
  val === 1 ||
  val === "1";

export const getActiveValue = (record) =>
  record?.active ?? record?.activeStatus;

export const getNextActiveValue = (current) => {
  const currentlyActive = isRecordActive(current);
  if (typeof current === "boolean") return !current;
  if (
    current === "Y" ||
    current === "N" ||
    current === "y" ||
    current === "n"
  ) {
    return currentlyActive ? "N" : "Y";
  }
  return currentlyActive ? "N" : "Y";
};

export const isActiveRecord = (record, defaultActive = "Y") =>
  isRecordActive(getActiveValue(record) ?? defaultActive);

export const filterActiveRecords = (list, defaultActive = "Y") =>
  (Array.isArray(list) ? list : [])?.filter((li) =>
    isActiveRecord(li, defaultActive),
  );
